export default __webpack_public_path__ + "static/media/reverted-waves.6a54c23a.svg";